import $ from 'jquery';

$(document).ready(function () {
	$('.tabs-product-page a').on('click', function (e) {
		e.preventDefault();
		let parent = $(this).parents('.tabs-product-page').parent();
		parent.find('a').removeClass('active');
		$(this).addClass('active');
		parent.find('.tab-view').hide();
		parent.find('[data-tab="' + $(this).data('id') + '"]').show();
	});

	$('.frontpage-tabs a').on('click', function (e) {
		e.preventDefault();

		$('.product-tab').css('display','none');
		$('.frontpage-tabs a').removeClass('active');
		$(this).addClass('active');
		$('.tab-view').removeClass('active');
		$('#' + $(this).data('id')).addClass('active');
		$('#product-tab-' + $(this).data('id').replace('frontpage-tab-', '')).css('display','block');

	});

	$('.tabs-product-page-product-slider a').on('click', function (e) {
		e.preventDefault();
		let parent = $(this).parents('.tabs-product-page-product-slider');
		let slider = parent.parents('.product-slider');
		parent.find('a').removeClass('active');
		$(this).addClass('active');
		slider.find('.tab-view').hide();
		slider.find('[data-tab="' + $(this).data('id') + '"]').show();
	});


	$('.scrollify-slide ul.list li').on('click', function(e){
		$(this).toggleClass('open')
	});
});
